export default __webpack_public_path__ + "static/media/free.b24dc2bc.svg";